<template>
  <Alert
    v-if="shouldShowBanner"
    variant="warning"
    :message="announcementText"
    :icon="Megaphone"
    :icon-size="32"
    custom-class="mb-6"
  />
</template>

<script>
import { Megaphone } from "lucide-vue";
import Alert from "@/components/ui/Alert.vue";

export default {
  name: "AnnouncementBanner",
  components: {
    Alert
  },
  data() {
    return {
      Megaphone
    };
  },
  computed: {
    announcementText() {
      const settings = this.$store.getters.getStore?.orderLiveSettings || {};
      const text = settings.oo_announcement || settings.ooAnnouncement || "";
      return typeof text === "string" ? text.trim() : "";
    },
    shouldShowBanner() {
      return !!this.announcementText;
    }
  }
};
</script>
